import React, { useEffect, useState } from "react";

interface EnterpriseModalProps {
  visible: boolean;
  title: string;
  onClose: () => void;
  children?: React.ReactNode;
  width?: number;
}

const EnterpriseModal: React.FC<EnterpriseModalProps> = ({
  visible,
  title,
  onClose,
  children,
  width = 540,
}) => {
  const [chatOpen, setChatOpen] = useState(false);

  // 检测 AI 对话框是否打开（chat-open class 由 index.html 中的脚本维护）
  useEffect(() => {
    if (!visible) return;
    // 立即读取一次，避免闪烁
    const btn = document.getElementById('fastgpt-chatbot-button');
    setChatOpen(btn?.classList.contains('chat-open') ?? false);
    // 持续监听状态变化
    const check = setInterval(() => {
      const b = document.getElementById('fastgpt-chatbot-button');
      setChatOpen(b?.classList.contains('chat-open') ?? false);
    }, 300);
    return () => clearInterval(check);
  }, [visible]);

  // ESC 键关闭
  useEffect(() => {
    if (!visible) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 flex items-center"
      style={{
        backgroundColor: "rgba(0,0,0,0.45)",
        zIndex: 2147483646,
        justifyContent: chatOpen ? "flex-start" : "center",
        paddingLeft: chatOpen ? 80 : 0,
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="bg-white rounded-xl shadow-2xl overflow-hidden flex flex-col"
        style={{ width, height: 520 }}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200 bg-gradient-to-r from-slate-50 to-white flex-shrink-0">
          <div className="flex items-center gap-2">
            <i className="ri-bar-chart-grouped-line text-blue-500 text-sm" />
            <h3 className="text-sm font-semibold text-slate-700">{title}</h3>
          </div>
          <button
            onClick={onClose}
            className="w-6 h-6 flex items-center justify-center rounded-full hover:bg-slate-200 text-slate-400 hover:text-slate-600 cursor-pointer transition-colors"
          >
            <i className="ri-close-line text-sm" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto px-4 py-3">
          {children}
        </div>
      </div>
    </div>
  );
};

export default EnterpriseModal;
